import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import * as actions from '../actions/event-map.actions';
import {EventMaps} from '../../../models/events';


export interface State extends EntityState<EventMaps> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<EventMaps> = createEntityAdapter<EventMaps>({
  selectId: eventMap => eventMap.num
});

export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(state = initialState, action: actions.EventMapActions): State {
  switch (action.type) {
    case actions.EventMapActionTypes.GetEventMaps:
      return {...state, Loaded: false, Loading: true};
    case actions.EventMapActionTypes.LoadEventMaps:
      return adapter.setAll(action.payload, {...state, Loaded: true, Loading: false});
    case actions.EventMapActionTypes.ChangeLanguageEventMaps:
      return {...state, Loaded: false, Loading: true};
    case actions.EventMapActionTypes.GetEventMapsFail:
      return {...state, Loaded: true, Loading: false};

    default:
      return state;
  }
}
